import { buildHeader, buildSecureApiHeader, buildQueryParam } from "./baseService";
import { getJson } from "../utils/httpHelper";

export const getSubscriptionPlans = async (baseUrl, apiKey, channelId, params) => {
  const subscriptionPlans = await fetch(
    buildQueryParam(`${baseUrl}/subscription-plan/${channelId}/list/`, params),  
    {  
      method: "GET",
      headers: buildHeader(apiKey),
    }
  );
  return getJson(subscriptionPlans);
};

export const processSubscriptionCheckout = async (baseUrl, data) => {
  const response = await fetch(
    `${baseUrl}/billing/subscription/subscribe/`,
    {
      method: "POST",
      headers: buildSecureApiHeader(),
      body: data,
    }
  );
  const responseJson = getJson(response);
  if (response.status !== 200) {
    return {
      status: "F",
      message: responseJson.message,
    };
  }
  return { status: "S", message: responseJson };
};

export const verifyCouponCode = async (baseUrl, apiKey, data) => {
  const response = await fetch(
    `${baseUrl}/billing/offer/verify/`,
    {
      method: "POST",
      headers: buildHeader(apiKey),
      body: data,
    }
  );

  return getJson(response);
}

export const purchasePPVOrder = async (baseUrl, apiKey, data) => {
  const response = await fetch(
    `${baseUrl}/billing/order/purchase/`,
    {
      method: "POST",
      headers: buildHeader(apiKey),
      body: data,
    }
  );

  return getJson(response);
}

export const purchaseSubscription = async (baseUrl, apiKey, data) => {
  const response = await fetch(
    `${baseUrl}/billing/subscription/subscribe/`,
    {
      method: "POST",
      headers: buildHeader(apiKey),
      body: data,
    }
  );

  return getJson(response);
}

export const generateDpoPayPortal = async (baseUrl, apiKey, data) => {
  try {
    const response = await fetch(`${baseUrl}/billing/subscription/generate-dpo-pay-portal/`, 
      {
        method: "POST",
        headers: buildHeader(apiKey),
        body: JSON.stringify({ data }),
      });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `DPO Pay Portal request failed with status ${response.status}: ${errorData.error || "Unknown error"}`
      );
    }

    const { payment_url } = await response.json();
    return payment_url;
  } catch (error) {
    console.error("Error generating DPO Pay Portal:", error);
    throw error;
  }
};

export const verifyTransaction = async (baseUrl, apiKey,companyToken, transactionToken) => {
  try {
    // API endpoint for transaction verification
    const endpoint = `${baseUrl}/billing/subscription/verify-dpo-transaction/`;

    // Make the POST request
    const response = await fetch(endpoint, {
      method: "POST",
      headers: buildHeader(apiKey),
      body: JSON.stringify({ companyToken, transactionToken }),
    });

    // Check if the response is successful
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Verification failed with status ${response.status}: ${
          errorData.error || "Unknown error"
        }`
      );
    }

    // Parse the JSON response
    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error during transaction verification:", error);
    throw new Error("Verification failed. Please try again later.");
  }
};

export const getActiveGateway = async (baseUrl) => { 
  const response = await fetch(`${baseUrl}/gateway-setting/list/`, {
    headers: buildSecureApiHeader(),
  });

  const gateways = await getJson(response);
  return gateways.filter(gateway => gateway.is_default)[0];
}

export const getGatewayActive = async (baseUrl, apiKey) => {
  const response = await fetch(`${baseUrl}/gateway-setting/list/`, {
    headers: buildHeader(apiKey),
  });

  const gateways = await getJson(response);
  return gateways.filter(gateway => gateway.is_default)[0];
}

export const appContentAccess = async (baseUrl, apiKey) => {
  const response = await fetch(`${baseUrl}/billing/subscription/app-content/`, {
    headers: buildHeader(apiKey),
  });

  return await getJson(response);
}
